/**
 * Позволяет сгруппировать несколько config extenders
 */
export function createConfigExtendersCollection() {
    const configExtenders = [];
    const func = (axiosConfig, params) => {
        let modifiedConfig = axiosConfig;
        configExtenders.forEach((configExtender) => {
            modifiedConfig = configExtender(modifiedConfig, params);
        });
        return modifiedConfig;
    };
    const result = func;
    result.add = (configExtender) => {
        configExtenders.push((axiosConfig, params) => configExtender(axiosConfig, params));
        return result;
    };
    return result;
}
